import React from 'react';
import { Star, ShieldCheck, FileDown } from 'lucide-react';
export function TrustBadges() {
  return <section className="py-6 px-4" data-id="element-147">
      <div className="max-w-4xl mx-auto bg-white border border-blue-100 rounded-xl shadow-sm p-4 md:p-6 flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12" data-id="element-148">
        <div className="flex items-center gap-2 text-slate-800 font-semibold text-lg" data-id="element-149">
          <Star className="w-6 h-6 text-blue-600 fill-blue-600" data-id="element-150" />
          <span data-id="element-151">4.8/5.0</span>
        </div>

        <div className="hidden md:block w-px h-8 bg-blue-100" data-id="element-152"></div>

        <div className="flex items-center gap-2 text-slate-800 font-semibold text-lg" data-id="element-153">
          <ShieldCheck className="w-6 h-6 text-blue-600" data-id="element-154" />
          <span data-id="element-155">Pago Seguro</span>
        </div>

        <div className="hidden md:block w-px h-8 bg-blue-100" data-id="element-156"></div>

        <div className="flex items-center gap-2 text-slate-800 font-semibold text-lg" data-id="element-157">
          <FileDown className="w-6 h-6 text-blue-600" data-id="element-158" />
          <span data-id="element-159">Entrega inmediata PDF</span>
        </div>
      </div>
    </section>;
}